import Vue from 'vue'
import App from './App.vue'
import store from '@/store'
import { router } from '@/plugins/router/system'
// import '@/utils/lodash'
import '@/assets/css/common.styl'

import { Toast, Icon, Overlay, Popup, SwipeCell, Loading, ImagePreview, Dialog, List } from 'vant'
import PointsTip from '@/components/points-tip'
Vue.use(Toast)
Vue.use(Icon)
Vue.use(Overlay)
Vue.use(Popup)
Vue.use(SwipeCell)
Vue.use(Loading)
Vue.use(ImagePreview)
Vue.use(Dialog)
Vue.use(List)
Vue.use(PointsTip)

// 动态设置title
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
Vue.config.productionTip = false
new Vue({
  store,
  router,
  render: (h) => h(App)
}).$mount('#app')
